module.exports = "https://web-assets.ifttt.com/packs/media/new_home/ios_download-fed7a4d5.svg";